import { createActions } from 'redux-actions';

import { CancerQuoteCompare } from '@models/CancerQuote';
import { CompareCancerQuoteParams } from '@apis/CancerQuoteApi';

export type State = {
  cancerQuotes?: CancerQuoteCompare[] | null;
};

export type CancerQuotesFetchPayload = CompareCancerQuoteParams;
export type StateUpdatePayload = Partial<State>;

export const {
  cancerQuotesFetch,
  stateUpdate,
} = createActions(
  'CANCER_QUOTES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'CANCER_QUOTE_COMPARE_PAGE',
  }
);
